/**
 * @fileoverview POST handler for the "/product_alerts" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { productAlertsIdCacheKeys } from "./constants";
import type { PostProductAlertProps, ProductAlertResultItem } from "./types";
import { isProductAlertResultItem } from "./validators";

export const postProductAlert = reactQueryMutationAdapter(
  productAlertsIdCacheKeys,
  async (props: PostProductAlertProps): Promise<ProductAlertResultItem> => {
    const response = await fetch("/product_alerts", "POST", props);

    if (!isProductAlertResultItem(response)) {
      throw new Error("Invalid product alert response");
    }

    return response;
  }
);
